import { render } from "./WorkerPanel.vue?vue&type=template&id=b8e5206c"
import script from "./WorkerPanel.vue?vue&type=script&lang=js"
export * from "./WorkerPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__